import store from '../../../vue/store'

export default {
  computed: {
    onlineStatus () {
      // eslint-disable-next-line
      return store.getters.onlineStatus
    }
  }
}
